export const excludedLocals = [
  "L99999", // test local
  "99999", // test local
  "seiu_ada", // test local
  "SEIU_ADA", // test local
  "00008FO",
  "00015",
  "00016",
  "00034Z",
  "00051",
  "00098",
  "00101",
  "00116",
  "00138",
  "00175",
  "00176",
  "00177",
  "00188",
  "00192B",
  "00200FO",
  "00211",
  "00226",
  "00246",
  "00263",
  "00265",
  "00276",
  "00280",
  "00300",
  "00316",
  "00334",
  "00400PG",
  "00401",
  "00444",
  "00506",
  "00551",
  "00553",
  "00560",
  "00563",
  "00572",
  "00580",
  "00598",
  "00612",
  "00620",
  "00621",
  "00704",
  "00722",
  "00777FO",
  "01990",
  "02007",
  "FIREOIL",
  "WUPHILA",
];
